var map = {
	"./": 36500,
	"./bill": 13499,
	"./bill.js": 13499,
	"./client": 32395,
	"./client.js": 32395,
	"./dropdownitem": 45947,
	"./dropdownitem.js": 45947,
	"./index": 36500,
	"./index.js": 36500,
	"./invoice": 54782,
	"./invoice-line": 83964,
	"./invoice-line.js": 83964,
	"./invoice-return": 59260,
	"./invoice-return-line": 66689,
	"./invoice-return-line.js": 66689,
	"./invoice-return.js": 59260,
	"./invoice.js": 54782,
	"./item": 39464,
	"./item.js": 39464,
	"./parcel": 26994,
	"./parcel.js": 26994,
	"./transaction": 63498,
	"./transaction.js": 63498
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64072;